import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { ConsentCheckbox } from '../ConsentCheckbox'
import { ConsentSection } from '../ConsentSection'
import { ConsentSectionFieldsProps } from '../types'

export function PricingConsentSection({ consents, updateConsent }: ConsentSectionFieldsProps) {
  return (
    <ConsentSection title={t`Pricing Conditions`} required>
      <div className="flex flex-col gap-2 rounded-lg bg-gray-50 p-4">
        <div className="flex justify-between gap-4">
          <span className="text-sm text-gray-600">
            <Trans>Consultation fee</Trans>
          </span>
          <span className="text-sm font-semibold text-gray-900">
            <Trans>See in next step</Trans>
          </span>
        </div>
        <p className="text-xs text-gray-500">
          <Trans>The exact fee and your out-of-pocket cost will be communicated before final validation of your appointment.</Trans>
        </p>
      </div>
      <ConsentCheckbox name="acceptedPricing" label={t`I accept the pricing conditions`} checked={consents.acceptedPricing} onChange={(checked) => updateConsent('acceptedPricing', checked)} required />
    </ConsentSection>
  )
}
